<template>
  <div class="flex">
    <a-upload
      :disabled="disabled"
      v-model:file-list="fileList"
      :show-upload-list="false"
      name="file"
      list-type="picture-card"
      :action="url"
      :before-upload="beforeUpload"
      @change="handleChange"
      :accept="accept"
      :headers="headers"
    >
      <img
        v-if="imageUrl"
        width="100"
        height="100"
        style="object-fit: contain;"
        :src="imageUrl"
        alt="avatar"
      />
      <div v-else>
        <loading-outlined v-if="loading"></loading-outlined>
        <plus-outlined v-else></plus-outlined>
      </div>
    </a-upload>
    <div class="tips">
      <p>1、尺寸限制: 74*74</p>
      <p>2、图片上传大小限制为200K,格式为<br />JPG、PNG、GIF</p>
    </div>
  </div>
  <a-modal
    :visible="previewVisible"
    :title="previewTitle"
    :footer="null"
    @cancel="handleCancel"
  >
    <img alt="example" style="width: 100%" :src="previewImage" />
  </a-modal>
</template>
<script>
import { PlusOutlined, LoadingOutlined } from '@ant-design/icons-vue'
import { message } from 'ant-design-vue'
import { computed, defineComponent, reactive, toRefs } from 'vue'
function getBase64(img, callback) {
  const reader = new FileReader()
  reader.addEventListener('load', () => callback(reader.result))
  reader.readAsDataURL(img)
}
const url = `${process.env.VUE_APP_CMS}/cms/material/upload`
export default defineComponent({
  components: {
    LoadingOutlined,
    PlusOutlined
  },
  props: ['imageUrl', 'disabled'],

  setup(props, { emit }) {
    const state = reactive({
      accept: 'image/*',
      fileList: [],
      loading: false,
      imageUrl: computed({
        get: () => {
          return props.imageUrl
        },
        set: v => {
          return v
        }
      }),
      url,
      previewVisible: false,
      previewTitle: '1',
      handleCancel() {
        state.previewVisible = false
        state.previewTitle = ''
      },
      handlePreview: async file => {
        if (!file.url && !file.preview) {
          file.preview = await getBase64(file.originFileObj)
        }
        state.previewImage = file.url || file.preview
        state.previewVisible = true
        state.previewTitle =
          file.name || file.url.substring(file.url.lastIndexOf('/') + 1)
      },
      headers: {
        Authorization:
          localStorage.getItem('token') || '0e044f64c5364f93a5cb83731a09b8b9'
      },
      isSizeList: (file, proportion) => {
        return new Promise((resolve, reject) => {
          let _URL = window.URL || window.webkitURL
          let img = new Image()
          img.onload = () => {
            let valid = img.width / img.height === proportion
            valid ? resolve(true) : reject(false)
          }
          img.src = _URL.createObjectURL(file)
        })
      },

      handleChange: info => {
        if (info.file.status === 'uploading') {
          state.loading = true
          return
        }
        if (info.file.status === 'done') {
          // eslint-disable-next-line no-unused-vars
          getBase64(info.file.originFileObj, base64Url => {
            state.imageUrl = base64Url
          })
          state.loading = false

          const imgUrl = info.fileList.pop()?.response.data.url
          emit('update:imageUrl', imgUrl)
        }
        if (info.file.status === 'error') {
          state.loading = false
          message.error('upload error')
        }
      },
      beforeUpload: async file => {
        const isJpgOrPng =
          file.type === 'image/jpeg' ||
          file.type === 'image/png' ||
          file.type === 'image/gif'
        if (!isJpgOrPng) {
          message.error('只能上传JPG、PNG、GIF格式的图片!')
          return Promise.reject()
        }
        const isLt200K = file.size / 1024 < 200
        if (!isLt200K) {
          message.error('图片最大为200K!')
          return Promise.reject()
        }
        let isSizes = false
        isSizes = await state.isSizeList(file, 1).catch(() => {
          isSizes = false
        })
        console.log('isSizes', isSizes)

        if (!isSizes) {
          message.error('图片比例不正确')
          return Promise.reject()
        }

        return isJpgOrPng && isLt200K && isSizes
      }
    })

    return {
      ...toRefs(state)
    }
  }
})
</script>
<style scoped lang="scss">
.flex {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  .tips {
    color: #999;
  }
}
.avatar-uploader > .ant-upload {
  width: 128px;
  height: 128px;
}

.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
::v-deep(.ant-upload-picture-card-wrapper) {
  width: 128px;
}
</style>
